// Handlers específicos del modal NotificationsModal

import React, { useCallback } from 'react';
import { ISystemNotification } from '../../../types/interfaces/INotifications';

interface UseNotificationsModalHandlersProps {
  // Estados
  setTabValue: (value: number) => void;

  // Funciones
  handleMarkAsRead: (id: string) => Promise<any>;
  handleMarkAsUnread: (id: string) => Promise<any>;
  handleDeleteNotification: (id: string) => Promise<any>;
  handleMarkAllAsRead: () => Promise<any>;

  // Datos
  tabValue: number;
  notifications: ISystemNotification[];
}

export const useNotificationsModalHandlers = ({
  setTabValue,
  handleMarkAsRead,
  handleMarkAsUnread,
  handleDeleteNotification,
  handleMarkAllAsRead,
  tabValue,
  notifications,
}: UseNotificationsModalHandlersProps) => {
  const handleTabChange = useCallback(
    (_event: React.SyntheticEvent, newValue: number) => {
      setTabValue(newValue);
    },
    [setTabValue]
  );

  const onMarkAsRead = useCallback(
    async (id: string) => {
      try {
        await handleMarkAsRead(id);
      } catch (error) {
        // Error manejado por el hook
      }
    },
    [handleMarkAsRead]
  );

  const onMarkAsUnread = useCallback(
    async (id: string) => {
      try {
        await handleMarkAsUnread(id);
      } catch (error) {
        // Error manejado por el hook
      }
    },
    [handleMarkAsUnread]
  );

  const onDeleteNotification = useCallback(
    async (id: string) => {
      try {
        await handleDeleteNotification(id);
      } catch (error) {
        // Error manejado por el hook
      }
    },
    [handleDeleteNotification]
  );

  const onMarkAllAsRead = useCallback(async () => {
    try {
      await handleMarkAllAsRead();
    } catch (error) {
      // Error manejado por el hook
    }
  }, [handleMarkAllAsRead]);

  const getFilteredNotifications = useCallback(() => {
    switch (tabValue) {
      case 0:
        return notifications;
      case 1:
        return notifications.filter(n => !n.read);
      case 2:
        return notifications.filter(n => n.actionRequired);
      case 3:
        return notifications.filter(
          n => n.priority === 'urgent' || n.priority === 'high'
        );
      default:
        return notifications;
    }
  }, [tabValue, notifications]);

  return {
    handleTabChange,
    onMarkAsRead,
    onMarkAsUnread,
    onDeleteNotification,
    onMarkAllAsRead,
    getFilteredNotifications,
  };
};
